import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Paper,
  Skeleton,
  Typography,
} from "@mui/material";
import { useGet } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { fullName } from "../../actprep-ui/utils/formatting";

export default function OnlineEmployeesDialog({ ...disclosureProps }) {
  const { data, isLoading } = useGet(apiUrls.admin.adminProfiles(), {
    params: {
      keep_related: true,
      search_params: {
        user_profile__is_clocked_in: true,
      },
      exclude: ["roles__team"],
    },
    enabled: disclosureProps.open,
    staleTime: 0,
  });

  const renderSkeletons = () =>
    Array.from({ length: 3 }).map((_, idx) => (
      <ListItem alignItems="flex-start" key={idx} divider>
        <ListItemAvatar>
          <Skeleton variant="circular" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton width="40%" />}
          secondary={<Skeleton width="60%" />}
        />
      </ListItem>
    ));

  const employees = data?.data || [];

  return (
    <Dialog {...disclosureProps} maxWidth="xs" fullWidth>
      <DialogTitle>Online Employees</DialogTitle>
      <DialogContent>
        <List
          component={Paper}
          elevation={0}
          sx={(theme) => ({
            backgroundColor: theme.palette.background.secondary,
          })}
          disablePadding
        >
          {isLoading ? (
            renderSkeletons()
          ) : employees.length > 0 ? (
            employees.map((adminProfile, i) => {
              const name = fullName(adminProfile.user);
              const profilePic = adminProfile.user_profile.profile_pic;
              const roles = adminProfile.roles.map(({ title }) => title);
              return (
                <ListItem
                  alignItems="flex-start"
                  key={i}
                  divider={i < employees.length - 1}
                >
                  <ListItemAvatar>
                    <Avatar src={profilePic} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={name}
                    slotProps={{
                      secondary: {
                        component: "div",
                      },
                    }}
                    secondary={roles.join(", ")}
                  />
                </ListItem>
              );
            })
          ) : (
            <ListItem>
              <ListItemText
                primary={
                  <Typography align="center" variant="body2">
                    No employees online.
                  </Typography>
                }
              />
            </ListItem>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={disclosureProps.onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
